import { render, staticRenderFns } from "./charge.vue?vue&type=template&id=5a1284c8"
import script from "./charge.vue?vue&type=script&lang=js"
export * from "./charge.vue?vue&type=script&lang=js"
import style0 from "./charge.vue?vue&type=style&index=0&id=5a1284c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports